import { useCallback } from 'react';
import { EStatKeys, TStats } from './use-fetch-event-overview-stats';

export const useIsLoadingStat = (data: TStats, isPublished: boolean) => {
  return useCallback(
    (statKey: EStatKeys) => {
      if (!isPublished) return false;

      const statCard = data?.[statKey];

      if (!statCard) return true;

      if (statCard.value === null || statCard.loading) return true;

      return false;
    },
    [data, isPublished]
  );
};
